import React from "react";
import { CountBox } from "./box";
import { CountBoxWrapper } from "./wrapper";

export const CountInfo = ({ count }) => {
  return (
    <CountBoxWrapper>
      <CountBox>{count}</CountBox>
    </CountBoxWrapper>
  );
};
